import { ModulesConfig, modules } from '../modules';
import { Resources } from '../ability';

import { NavigationItem, MetaTitle } from './router.types';

interface ModuleToNavigationParams {
  basename: string;
  resource: Resources;
  link?: string;
}

interface ModuleNavigationResult {
  aqaClass: string;
  href: string;
  resource: Resources;
  basename: string;
}

const moduleToNavigation = (
  { basename, resource, link }: ModuleToNavigationParams,
  parent?: string,
): ModuleNavigationResult => {
  const href =
    link ||
    `${parent && parent !== basename ? `/${parent}` : ''}${
      basename && '/'
    }${basename}`;

  return {
    aqaClass: `aqa${
      parent && parent !== basename ? `_${parent.replaceAll('-', '_')}` : ''
    }${basename && '_'}${basename.replaceAll('-', '_')}`,
    href,
    resource,
    basename,
  };
};

const createNavigation = (config: ModulesConfig): NavigationItem[] => {
  return Object.keys(config)
    .filter((key: string): key is keyof ModulesConfig => !!key)
    .filter((key) => config[key].withSide)
    .map((key) => {
      const module = config[key];

      return {
        ...moduleToNavigation(module),
        ...(key.includes('dropdown_')
          ? {
              submenu: Object.values(config)
                .filter(
                  (childModule) =>
                    childModule.basename.includes(module.basename) &&
                    childModule !== module,
                )
                .map((child) => moduleToNavigation(child, module.basename)),
            }
          : {}),
      };
    });
};

const navigationItems = createNavigation(modules);

// eslint-disable-next-line local-rules/no-export-constants
export const metaTitles: MetaTitle[] = [
  ...navigationItems.map(({ resource, basename, href, submenu }) => ({
    resource,
    basename,
    href,
    submenu,
  })),
  {
    completeTitle: {
      company: 'Вход в личный кабинет',
      employee: 'Вход в личный кабинет',
    },
    href: '/auth',
  },
  {
    completeTitle: { company: 'Личный кабинет', employee: 'Личный кабинет' },
    href: '/',
  },
  {
    completeTitle: { company: 'Заявки', employee: 'Заявки' },
    href: '/events',
  },
  {
    completeTitle: { company: 'Профиль', employee: 'Профиль' },
    href: '/profile',
  },
  {
    completeTitle: { company: 'Профиль', employee: 'Профиль' },
    href: '/create-certificate',
  },
  {
    completeTitle: {
      company: 'Расширенный поиск',
      employee: 'Расширенный поиск',
    },
    href: '/search',
  },
];
